import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import {MdDeleteForever, MdFilter1} from 'react-icons/md';
import {ICON_COLOR} from '../icon';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import AuthenticationService from '../services/AuthenticationService';
import MasterDataService from '../services/MasterDataService';
import "../css/style.css";

class CountryMappngList extends Component {
  constructor () {
    super();
    this.state = {
      countryCodes: [],
      searchCountryCode: "",
      countries: [],
      showCountry: false,
      selectedRow: 0,
      countryId: 0,
      countryCode: '',
      mappedInfo: '',
      columns : [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row =>(
            <div style={{ padding: "10px"}}>{row.index + 1}</div>
          )
        },        
        {
            Header: couterpart.translate('country_mapping_name'),
            accessor: 'code',
                     
        },
        {
            Header: couterpart.translate('country_mapping_info'),
            accessor: 'mappedInfo',
        },{                     
            Header: couterpart.translate('country_mapping_action'),
            accessor: 'action',
            width: 50,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                  {this.renderEditButton(row)}
              </div>
            )
        }
        ]
    };
  }

  renderEditButton(row){
    // const button_edit = couterpart.translate('button_edit');
    const button_delete = couterpart.translate('button_delete');
    if (AuthenticationService.isAdmin()){
      return (<div>
              <button className="myButton" onClick={() => this.handleDelete(row)}>
              <MdDeleteForever color={ICON_COLOR}/>
              &nbsp;{button_delete}</button>
                </div>
              );
    }else{
      return (<></>);
    }
  }

  handleDelete(e){
    let ans = window.confirm("Bạn có chắc muốn xóa quốc gia: " + e.original.code);
    if (ans == false) {
      return;
    }

    MasterDataService.deleteCountryMapping(e.original.id).then(data => {
      if (data.message === undefined){
        this.setState({ searchCountryCode :  ''} , () => {
          this.onFilter();
        });        
      }
    });
  }

  renderImage(row){
    if (row.original.content === undefined || row.original.content === null){
      return (<></>)
    }    
    return(
        <img className="imageBox linkTo" alt="" width={ 100 } height={70} src={`data:image/jpeg;base64,${row.original.content}`} name={ 'B' + row.original.name} />
    )
  } 

  componentDidMount () {
    MasterDataService.retrieveCountryMappings().then(data => {
      if (data.message === undefined){
        this.setState({ countries:  data })
      }else{
        this.setState({ countries:  [] })
      }
    });
      
  } 

  handleChange(e){
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }    
    var value = e.target.value;
    this.setState({ searchCountryCode :  value});
  }

  onFilter () {
    MasterDataService.retrieveCountryMappingsBy(this.state.searchCountryCode).then(data => {
      if (data.message === undefined){
        this.setState({ countries:  data })
      }else{
        this.setState({ countries:  [] })
      }
    });
  }

  onAddCountry(){
    this.setState({ showCountry: true });
  }

  handleCloseCountry(){
    this.setState({ showCountry: false });
  }

  saveAndCloseCountry() {
    let ret = this.applyMapping();
    if (ret === 1){
      this.setState({ showCountry: false }, () => {
        this.onFilter();
      });
    }
  }

  handleCountryCodeChange(e){
    let value = e.target.value;
    this.setState({                 
        countryCode: value
    });
  }

  handleMappingInfoChange(e) {
    let value = e.target.value;
    this.setState({                 
        mappedInfo: value
    });
  }

  applyMapping(){
    if (this.state.countryCode === null || this.state.countryCode === undefined || this.state.countryCode.trim().length < 1){
        alert('Xin nhập mã quốc gia');
        return 0;
    }        

    if (this.state.mappedInfo === null || this.state.mappedInfo === undefined || this.state.mappedInfo.trim().length < 1){
        alert('Xin nhập quốc gia shipping');
        return 0;
    } 

    let info = {
        code: this.state.countryCode,
        mappedInfo: this.state.mappedInfo
    }

    MasterDataService.saveCountryMapping(info).then(data => {
        if (data !== undefined && data.id > 0){
            alert("Thông tin cài đặt quôc gia đã được lưu.");
        } else {
            alert("Lỗi. Thông tin cài quôc gia chưa được lưu.");
        }
    });
    return 1;
  }  

  render() {
    if (!AuthenticationService.isAdmin()){
      return (<div>Unauthorized access.</div>);
    }
    return (
      <>
        <div className="row">
          <div className="col-12">
            <h4 style={{ marginTop: "30px"}}>{ couterpart.translate("country_mapping_title") }</h4>
          </div>
        </div>
        <div className="row">
          <div className="col-7">
            &nbsp;
          </div>
          <div className="col-1">
            <label style={{ margin: "5px", width: "100%"}}>{ couterpart.translate('country_mapping_name') }</label>
          </div>
          <div className="col-2">
            <input name="duration" type="text" size="40" style={{ margin: "5px", width: "100%"}}
              placeholder="" value={this.state.searchCountryCode}
              onChange={this.handleChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleChange(e) }, 0); }}  />
          </div>
          <div className="col-1">
            <button className="myButton" onClick={() => this.onFilter()} style={{ marginBottom: "10px"}}>
              <MdFilter1 color={ICON_COLOR}/>
              &nbsp;{ couterpart.translate('button_filter') }</button>
          </div>
          <div className="col-1">
            <button className="myButton" onClick={() => this.onAddCountry()} style={{ marginBottom: "10px"}}>
              <MdFilter1 color={ICON_COLOR}/>
              &nbsp;{ couterpart.translate('button_add') }</button>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <ReactTable
              NoDataComponent={() => null} 
              previousText={"<"}
              nextText={">"}
              data={this.state.countries}
              columns={this.state.columns}
              defaultPageSize = {3}
              showPageSizeOptions = {true}                
              pageSizeOptions = {[3, 5, 10, 20]}
              getTrProps={(state, rowInfo, column) => { 
                if (rowInfo && rowInfo.row) {
                  return {
                    onClick: (e) => {
                      this.setState({
                        selectedRow: rowInfo.index
                      });
                    },
                    style: {
                      background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                      color: rowInfo.index === this.state.selectedRow ? 'white' : 'black'
                    }
                  }
                }else{
                  return {}
                }
              }
            }
            />
          </div>
          <Modal show={this.state.showCountry} onHide={this.handleCloseCountry.bind(this)} backdrop="static"  dialogClassName="modal-40w">
            <Modal.Header closeButton>
                <Modal.Title>{ couterpart.translate('country_mapping_form') }</Modal.Title>
            </Modal.Header>
            <Modal.Body>                                                                                         
              <div className="row" style={{ marginTop: "5px" }}>
                  <div className="col-4">
                      <span className="field_margin">{ couterpart.translate('country_mapping_name') } : </span>
                  </div>                        
                  <div className="col-8">
                      <input type="text" name="countryCode" value={this.state.countryCode} onChange={this.handleCountryCodeChange.bind(this)}/>
                  </div>
              </div>
              <div className="row" style={{ marginTop: "5px" }}>
                  <div className="col-4">
                      <span className="field_margin">{ couterpart.translate('country_mapping_info') } : </span>
                  </div>                        
                  <div className="col-8">
                      <input type="text" name="mappedInfo" value={this.state.mappedInfo} onChange={this.handleMappingInfoChange.bind(this)}/>
                  </div>
              </div>    
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={this.handleCloseCountry.bind(this)}>Cancel</Button>
              <Button variant="primary" onClick={this.saveAndCloseCountry.bind(this)}>OK</Button>  
            </Modal.Footer>
          </Modal>
        </div>
      </>
    )
  }
}

export default CountryMappngList;